const omitArray = ["", null, undefined, NaN];

Array.prototype.compact = function () {
  return this.filter((item) => !omitArray.includes(item));
};
